<div class="Container my-5 text-center">
        <h1>COVID-19-TN | Localiser vous </h1>
        <p>Cette application n'a rien à voir avec le site Web du gouvernement <a href="http://www.covid-19.tn">www.covid-19.tn</a></p>
    <div class="my-5">
        <div class="row">
            <div class="col-sm-12">
                <div class="developer-bloc">
                    <img class="avatar" src="https://media-exp1.licdn.com/dms/image/C4D03AQGU1k0Ra6MUDA/profile-displayphoto-shrink_100_100/0?e=1590019200&v=beta&t=XBHgSPgHdFP6EO3IIWjiTlJVOg07NX8av3a_9gOFrRc" width="150px">
                    <h5>CHOURABI Taher</h5>
                    <p>SOFTWARE ENGINEER & PROJECT OWNER</p>
                    <a href="https://tn.linkedin.com/in/taher-chourabi-270749140"><i class="fab fa-linkedin-in"></i> LinkedIn</a> 
                </div>
            </div>

        </div>
    

    </div>







</div>